// Recovered compiled webpack factory 36798. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "serverPatchReducer", {
      enumerable: !0,
      get: function () {
        return c;
      },
    }));
  let n = r(29658),
    a = r(60895),
    o = r(44707),
    i = r(35737),
    s = r(77609),
    l = r(11126),
    u = r(17297);
  function c(e, t) {
    let {
        serverResponse: { flightData: r, canonicalUrl: c },
        navigatedAt: f,
      } = t,
      d = {};
    if (((d.preserveCustomHistoryState = !1), "string" == typeof r))
      return (0, i.handleExternalUrl)(e, d, r, e.pushRef.pendingPush);
    let p = e.tree,
      h = e.cache;
    for (let t of r) {
      let { segmentPath: r, tree: l } = t,
        _ = (0, a.applyRouterStatePatchToTree)(["", ...r], p, l, e.canonicalUrl);
      if (null === _) return e;
      if ((0, o.isNavigatingToNewRootLayout)(p, _))
        return (0, i.handleExternalUrl)(e, d, e.canonicalUrl, e.pushRef.pendingPush);
      let m = c ? (0, n.createHrefFromUrl)(c) : void 0;
      m && (d.canonicalUrl = m);
      let g = (0, u.createEmptyCacheNode)();
      ((0, s.applyFlightData)(f, h, g, t), (d.patchedTree = _), (d.cache = g), (h = g), (p = _));
    }
    return (0, l.handleMutable)(e, d);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
